import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { Button, SpinnerLoader } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { startPreparingDownload } from "~/store/actions/actions.prepareDownload.jsx";
import { getIsPreparingDownloadAllAttachments } from "~/store/selectors/selector.downloads.jsx";
import { useFileTokenContext } from "./FilePreview";

export const PrepareDownload = ({ url, label, preparingLabel, className }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { download_token } = useFileTokenContext();

  const isPreparingDownload = useSelector((state) => getIsPreparingDownloadAllAttachments(state));

  const startPreparingDownloadHandler = useCallback(() => {
    return dispatch(startPreparingDownload(url, download_token));
  }, [dispatch, download_token, url]);

  return (
    <div className={classNames("prepare_download", className)}>
      {!isPreparingDownload && (
        <Button
          onClick={startPreparingDownloadHandler}
          variant="outlined"
        >
          {label ? label : t("Download all attachments")}
        </Button>
      )}
      {isPreparingDownload && (
        <Button variant="outlined">
          <SpinnerLoader />
          <span className="tw-ml-1">{preparingLabel ? preparingLabel : t("Preparing download (zipping)")}</span>
        </Button>
      )}
    </div>
  );
};

PrepareDownload.propTypes = {
  url: PropTypes.string,
  label: PropTypes.string,
  preparingLabel: PropTypes.string,
  isPreparingDownload: PropTypes.bool,
  className: PropTypes.string,
};

PrepareDownload.defaultProps = {
  isPreparingDownload: false,
};
